module.exports = __webpack_public_path__ + "static/1-72218d61ba6a6fa357e628ed2d47bf7e.png";